import { render, staticRenderFns } from "./businessResource.vue?vue&type=template&id=d00f450a&"
import script from "./businessResource.vue?vue&type=script&lang=js&"
export * from "./businessResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports